import Loader from 'Lib/utilities/Loader';

const routes = [
	{
		path: '/bulk-operations/pods/:groupID([0-9]+)/add',
		component: Loader(() => import('~/containers/bulk-operations/pods/Add'))
	},
	{
		path: '/bulk-operations/pods/:groupID([0-9]+)/edit',
		component: Loader(() => import('~/containers/bulk-operations/pods/Edit'))
	}
];

export default routes;
